import { Component, HostListener, ViewEncapsulation } from '@angular/core';
import { WarningModalActions } from './warning.modal.actions';
import { MatDialogRef } from '@angular/material';

@Component({
    templateUrl: './unsaved.warning.modal.component.html',
    styleUrls: ['./unsaved.warning.modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class UnsavedWarningModalComponent {
    private isClosing: boolean;

    constructor(private dialog: MatDialogRef<UnsavedWarningModalComponent>,
                private actions: WarningModalActions) {
        this.dialog.afterClosed().subscribe(() => this.close());
    }

    @HostListener('keydown.esc')
    public close(): void {
        if (this.isClosing) {
            return;
        }

        this.isClosing = true;
        if (this.actions.keepWorking) {
            this.actions.keepWorking();
        }
        this.dialog.close();
    }

    public discard() {
        if (this.actions.discard) {
            this.actions.discard();
        }
        this.dialog.close();
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/unsaved.warning.modal/unsaved.warning.modal.component.ts